import { render } from "./LivingUnits.vue?vue&type=template&id=042ec5c3&scoped=true"
import script from "./LivingUnits.vue?vue&type=script&lang=js"
export * from "./LivingUnits.vue?vue&type=script&lang=js"

import "./LivingUnits.vue?vue&type=style&index=0&id=042ec5c3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042ec5c3"]])

export default __exports__